import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import "@/scss/vendor/foundation.scss"
import "@/scss/main.scss"

const pinia = createPinia()
const app = createApp(App)

app.use(pinia).use(router)

app.mount('#app')
